import type { ReactNode } from "react";

// Credibility band between the hero and the emotional anchor — four
// editorial cells split by hairlines, no card chrome. The numbers
// frame the problem (most denials are never appealed; the ones that
// are get overturned ~41% of the time).
interface Stat {
  number: ReactNode;
  label: string;
  source: string;
}

const STATS: Stat[] = [
  {
    number: (
      <>
        1<span className="px-0.5 text-[#C0BFB8]"> / </span>7
      </>
    ),
    label: "Claims denied on first submission",
    source: "KFF Marketplace Report, 2023",
  },
  {
    number: (
      <>
        &lt; 1<span className="text-[28px] text-[#C0BFB8]">%</span>
      </>
    ),
    label: "Ever formally appealed by patients",
    source: "CAQH / McKinsey Healthcare Study",
  },
  {
    number: (
      <span className="flex items-baseline text-forest">
        41<span className="text-[28px] text-[#5A8C72]">%</span>
      </span>
    ),
    label: "Of appealed denials overturned",
    source: "AMA Prior Authorization Survey, 2022",
  },
  {
    number: (
      <>
        <span className="text-[28px] text-[#C0BFB8]">$</span>1,300
      </>
    ),
    label: "Average value of a denied claim",
    source: "HFMA Claims Benchmarking",
  },
];

export function StatsStrip() {
  return (
    <section
      className="border-y-[0.5px] border-line bg-parchment"
      aria-label="The scale of denials"
    >
      <div className="mx-auto grid max-w-[1180px] grid-cols-4 px-6 max-[980px]:grid-cols-2 max-[640px]:grid-cols-1 sm:px-8">
        {STATS.map((stat) => (
          <div
            key={stat.label}
            className="lp-reveal border-line px-7 pb-10 pt-11 max-[980px]:px-[22px] max-[980px]:py-8 max-[640px]:px-[22px] max-[640px]:py-7 min-[981px]:border-r-[0.5px] min-[981px]:[&:last-child]:border-r-0 min-[641px]:max-[980px]:[&:nth-child(-n+2)]:border-b-[0.5px] min-[641px]:max-[980px]:[&:nth-child(odd)]:border-r-[0.5px] max-[640px]:border-b-[0.5px] max-[640px]:[&:last-child]:border-b-0"
          >
            <div className="mb-3.5 flex items-baseline font-serif text-[42px] font-normal leading-none tracking-[-0.02em] text-ink max-[980px]:text-[34px]">
              {stat.number}
            </div>
            <div className="mb-1.5 text-[13.5px] leading-[1.5] text-ink-soft">{stat.label}</div>
            <div className="text-[11px] italic tracking-[0.04em] text-ink-hint">{stat.source}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
